import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import MasterCardComponent from './MasterCardComponent';

const MasterUploadFiles = () => {
  const [selectedMasterType, setSelectedMasterType] = useState('BR_Corelation');
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const masterTypeFromURL = params.get('__master__') || params.get('__card__');

    if (masterTypeFromURL) {
      setSelectedMasterType(masterTypeFromURL);
      // console.log("selectedMasterType", selectedMasterType)
    } else {
      setSelectedMasterType('BR_Corelation');
    }
  }, [location]);

  const renderSelectedMaster = () => {
    switch (selectedMasterType) {
      case 'BR_Corelation':
      case 'Part_Number':
      case 'MASTER_HSN':
      case 'CCR':
      case 'USD_EX_RATE':
        return <MasterCardComponent key={selectedMasterType} title={selectedMasterType} />;
      default:
        return (
          <div className="text-center py-5">
            <h5>Select a valid master upload type</h5>
          </div>
        );
    }
  };

  return (
    <Fragment>
      <Row>
        <Col xl="12" lg="12">
          {renderSelectedMaster()}
        </Col>
      </Row>
    </Fragment>
  );
};

export default MasterUploadFiles;
